import React, {useEffect, useRef, useState} from 'react';
import DivDiagonal from "../../components/DivDiagonal";
import CardRankingWin from "../../components/Report/CardRankingWin";
import CardRankingLoss from "../../components/Report/CardRankingLoss";
import {dateCurrent, dateFirstDayCurrent, firstDayMonth} from "../../utils/date";
import * as Yup from "yup";
import {toast} from "react-toastify";
import messageTypes from "../../constants/MessagesTypes";
import {Form} from "@unform/web";
import CustomButton from "../../components/Form/Button";
import {AiOutlineSearch} from "react-icons/ai";
import GeneralDoughnut from "../../components/Charts/GeneralDoughnut";
import TradingAgroupMonth from "../../components/Charts/TradingAgroupMonth";
import {useSelector} from "react-redux";
import {useHistory} from "react-router-dom";
import InputDate from "../../components/Form/InputDate";
import StrategyReport from "../../components/Report/StrategyReport";
import {useTranslation} from "react-i18next";
import InputSelect from "../../components/Form/InputSelect";
import {
    TradingWrapper,
    ContentArea,
    TradingListPageHeader,
    TradingBelowHeaderSection,
    FilterTitle,
    StyledFilterFormWrapper,
    FilterRow,
    FilterField,
    FilterButtonWrap,
} from "../Trading/styles";
import {
    DashboardFilterCard,
    DashboardFilterSection,
    DashboardTopGrid,
    DashboardSplitGrid,
    DashboardPanel,
} from "./styles";

const filterSearchBtnStyle = {
    background: 'linear-gradient(135deg, #f29205 0%, #ff6b35 100%)',
    border: 'none',
    color: '#ffffff',
    padding: '0 28px',
    borderRadius: '10px',
    fontWeight: 600,
    boxShadow: '0 4px 15px rgba(242, 146, 5, 0.3)',
    transition: 'all 0.3s ease',
    width: 'auto',
    minWidth: 'auto',
    height: '56px',
    display: 'flex',
    alignItems: 'center',
};

export default function Dashboard() {
    const formRef = useRef(null);
    const [year,] = useState(new Date().getFullYear());
    const history = useHistory();
    const { t } = useTranslation();
    const optionsDirection = [
        {key: 'COMPRA', value: t('trading_label_input_direction_select_option_1')},
        {key: 'VENDA', value: t('trading_label_input_direction_select_option_2')},
    ];

    const { id } = useSelector(
        (state) => state.BankReducer
    );

    const [filter, setFilter] = useState([
        {
            startDate: dateFirstDayCurrent(),
            endDate: dateCurrent(),
        }
    ]);

    useEffect(() => {
        if (id === 0) {
            history.push('/bank');
        }
        document.getElementById('body').className = 'page-top'
    }, [id]);

    async function handleSubmit(data) {
        try {

            formRef.current.setErrors({});
            const schema = Yup.object().shape({});

            await schema.validate(data, {
                abortEarly: false,
            });

            setFilter(
                [{
                    startDate: data.startDate,
                    endDate: data.endDate,
                    direction: data.direction
                }]
            );

        } catch (err) {
            if (err instanceof Yup.ValidationError) {
                const validationErrors = {};
                err.inner.forEach((error) => {
                    validationErrors[error.path] = error.message;
                });
                formRef.current.setErrors(validationErrors);
                toast.warning(messageTypes.REQUIRED_FIELDS);
                return;
            }

            toast.error(messageTypes.ERROR);
        }
    }

    return (
        <>
            {(id !== 0 && id !== null) && (
                <TradingWrapper>
                    <DivDiagonal/>
                    <ContentArea>
                        <TradingListPageHeader>
                            <h1>
                                <i className="fas fa-fw fa-tachometer-alt" aria-hidden="true"/>
                                Dashboard
                            </h1>
                        </TradingListPageHeader>

                        <TradingBelowHeaderSection>
                            <DashboardFilterCard>
                                <DashboardFilterSection>
                                    <StyledFilterFormWrapper>
                                        <Form ref={formRef} onSubmit={handleSubmit}>
                                            <FilterTitle>
                                                <i className="fas fa-funnel-dollar" aria-hidden="true"/> {t('filter')}
                                            </FilterTitle>
                                            <FilterRow>
                                                <FilterField>
                                                    <InputDate
                                                        name="startDate"
                                                        label={t('filter_start_date')}
                                                        value={firstDayMonth()}
                                                        size={"small"}
                                                    />
                                                </FilterField>
                                                <FilterField>
                                                    <InputDate
                                                        name="endDate"
                                                        label={t('filter_end_date')}
                                                        value={new Date()}
                                                        size={"small"}
                                                    />
                                                </FilterField>
                                                <FilterField>
                                                    <InputSelect
                                                        type="text"
                                                        name="direction"
                                                        label={t('trading_label_input_direction')}
                                                        options={optionsDirection}
                                                        defaultValue={''}
                                                        size={"small"}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                </FilterField>
                                                <FilterButtonWrap>
                                                    <CustomButton
                                                        className="btn font-weight-bold text-capitalize mobile-button"
                                                        type="submit"
                                                        startIcon={<AiOutlineSearch/>}
                                                        style={filterSearchBtnStyle}
                                                        onMouseEnter={(e) => {
                                                            e.currentTarget.style.transform = 'translateY(-2px)';
                                                            e.currentTarget.style.boxShadow = '0 6px 20px rgba(242, 146, 5, 0.4)';
                                                        }}
                                                        onMouseLeave={(e) => {
                                                            e.currentTarget.style.transform = 'translateY(0)';
                                                            e.currentTarget.style.boxShadow = '0 4px 15px rgba(242, 146, 5, 0.3)';
                                                        }}
                                                    >
                                                        {t('filter_btn_submmit')}
                                                    </CustomButton>
                                                </FilterButtonWrap>
                                            </FilterRow>
                                        </Form>
                                    </StyledFilterFormWrapper>
                                </DashboardFilterSection>
                            </DashboardFilterCard>

                            <DashboardTopGrid>
                                <DashboardPanel>
                                    <CardRankingWin filter={filter}/>
                                </DashboardPanel>
                                <DashboardPanel>
                                    <CardRankingLoss filter={filter}/>
                                </DashboardPanel>
                                <DashboardPanel>
                                    <div className="card shadow mb-4 h-100">
                                        <div className="card-header py-3">
                                            <div className="row">
                                                <div className="col d-flex flex-column justify-content-center">
                                                    <span className="m-0 font-weight-bold">
                                                        <nobr>
                                                            <i className="fas fa-info-circle fa-1x"/> {t('report_general_doughnut_title')}
                                                        </nobr>
                                                    </span>
                                                </div>
                                                <div className="col">
                                                    <div className="float-right">
                                                        <i className="fas fa-chart-pie fa-1x"/>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card-body pb-0 mb-0">
                                            <GeneralDoughnut
                                                filter={filter}
                                            />
                                        </div>
                                    </div>
                                </DashboardPanel>
                            </DashboardTopGrid>

                            <DashboardSplitGrid>
                                <DashboardPanel>
                                    <div className="card shadow mb-4 h-100">
                                        <div className="card-header py-3">
                                            <div className="row">
                                                <div className="col d-flex flex-column justify-content-center">
                                                    <span className="m-0 font-weight-bold">
                                                        <i className="fa fa-list"/> {t('report_strategies_title')}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card-body pb-0 mb-0 dashboard-strategy-card-body">
                                            <StrategyReport
                                                filter={filter}
                                            />
                                        </div>
                                    </div>
                                </DashboardPanel>

                                <DashboardPanel>
                                    <div className="card shadow mb-4 h-100">
                                        <div className="card-header py-3">
                                            <div className="row">
                                                <div className="col d-flex flex-column justify-content-center">
                                                    <span className="m-0 font-weight-bold">
                                                        <nobr><i className="far fa-calendar-alt"/> {t('report_month_title')} - {year}</nobr>
                                                    </span>
                                                </div>
                                                <div className="col">
                                                    <div className="float-right">
                                                        <i className="fas fa-chart-bar fa-1x"/>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card-body pb-0 mb-0">
                                            <TradingAgroupMonth
                                                year={year}
                                                filter={filter}
                                            />
                                        </div>
                                    </div>
                                </DashboardPanel>
                            </DashboardSplitGrid>
                        </TradingBelowHeaderSection>
                    </ContentArea>
                </TradingWrapper>
            )}
        </>
    )
}
